import { SignupNameStep } from "@/components/auth/SignupNameStep";
import { usePageTitle } from "../hooks/usePageTitle";

export function SignupNamePage() {
  usePageTitle("Your name | TidyRota");

  return <SignupNameStep />;
}
